export const NAVIGATION_RESPONSABLE_OFA: any[] = [
  {
    heading: true,
    title: 'OFA'
  },
  {
    'title': 'MES OFA',
    'url': '/mes-ofa',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mes propositions',
        'url': '/propositions',
        'service': 'ofa'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },
  {
    'heading': true,
    'title': 'DATABOOK'
  },
  {
    'title': 'Moi',
    'url': '/mon-databook',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mon DataBook',
        'url': '/moi',
        'service': 'ofa'
      },
      {
        'title': 'Mes historiques ofa',
        'url': '/mes-historiques-ofa',
        'service': 'ofa'
      },
      {
        'title': 'Mes historiques hors ofa',
        'url': '/mes-historiques-horsofa',
        'service': 'ofa'
      },
    ],
  },
  {
    'title': 'Mes collaborateurs',
    'url': '/mon-databook/collaborateurs',
    'service': 'ofa',
    'icon': 'ft-users'
  },

];

export const NAVIGATION_DIRECTEUR: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Ma structure OFA',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Affectations OFA',

        'url': '/affectations-ofa',

        'service': 'ofa'

      }

    ]

  },



  {

    'title': 'MES OFA',

    'url': '/mes-ofa',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mes propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Mon arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    title: 'Conseil de direction',

    url: '/conseil-direction',

    icon: 'ft-book-open',

    childrens: [

      {

        title: 'Propositions',

        url: '/propositions'

      },

      {

        title: 'Session d\'arbitrage',

        url: '/session-arbitrage'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },


  {

    'heading': true,

    'title': 'DATABOOK'

  },

  {

    'title': 'Moi',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [
      {

        'title': 'Mon DataBook',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques ofa',

        'url': '/mes-historiques-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques hors ofa',

        'url': '/mes-historiques-horsofa',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Mes collaborateurs',

    'url': '/mon-databook/collaborateurs',

    'service': 'ofa',
    'icon': 'ft-users'

  },

]

export const NAVIGATION_DIRECTEUR_HIERARCHIE: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },
  {

    'heading': true,

    'title': 'OFA'

  },
  {

    'title': 'Ma structure OFA',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Affectations OFA',

        'url': '/affectations-ofa',

        'service': 'ofa'

      }

    ]

  },



  {

    'title': 'MES OFA',

    'url': '/mes-ofa',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mes propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Mon arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    title: 'Conseil de direction',

    url: '/conseil-direction',

    icon: 'ft-book-open',

    childrens: [

      {

        title: 'Propositions',

        url: '/propositions'

      },

      {

        title: 'Session d\'arbitrage',

        url: '/session-arbitrage'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },


  {

    'heading': true,

    'title': 'DATABOOK'

  },

  {

    'title': 'Moi',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mon DataBook',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques ofa',

        'url': '/mes-historiques-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques hors ofa',

        'url': '/mes-historiques-horsofa',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Mes collaborateurs',

    'url': '/mon-databook/collaborateurs',

    'service': 'ofa',
    'icon': 'ft-users'


  },

]

export const NAVIGATION_DRHA: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    title: 'Conseil de direction',

    url: '/conseil-direction',

    icon: 'ft-book-open',

    childrens: [

      {

        title: 'Propositions',

        url: '/propositions'

      },

      {

        title: 'Session d\'arbitrage',

        url: '/session-arbitrage'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Campagne OFA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Reporting',

        'url': '/reporting-ofa',

        'service': 'ofa'

      },

    ]

  }

]

export const NAVIGATION_CONSEIL: any[] = [
  {
    'heading': true,
    'title': 'OFA'
  },
  {
    title: 'Conseil de direction',
    url: '/conseil-direction',
    icon: 'ft-book-open',
    childrens: [
      {
        title: 'Propositions',
        url: '/propositions'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },
  {
    'title': 'Campagne OFA',
    'url': '/campagne',
    'icon': 'ft-compass',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Reporting',
        'url': '/reporting-ofa',
        'service': 'ofa'
      },
    ]
  }
]

export const NAVIGATION_GRH: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Gestion OFA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'ofa',

    'childrens': [
      {
        'title': 'Referentiels',
        'url': '',
        'service': 'ofa',
        'childrens': [

          {

            'title': 'Campagnes',

            'url': '/initialisation-ofa',

            'service': 'eia'

          },

          {

            'title': 'Agents',

            'url': '/agents-ofa',

            'service': 'ofa'

          },

          {

            'title': 'Infos salaires',

            'url': '/infos-salaires',

            'service': 'ofa'

          },
          {

            'title': 'Affectations',

            'url': '/affectations',

            'service': 'ofa'

          },
          {

            'title': 'Structures',

            'url': '/structures',

            'service': 'ofa'

          },
        ]
      },

      {
        'title': 'Analyse',
        'url': '',
        'service': 'ofa',
        'childrens': [
          {

            'title': 'Analyse Multidimensionnelle',

            'url': '/analyse-multicritere',

            'service': 'ofa'

          },
          {

            'title': 'TB Suivi exécution',

            'url': '/tb-suivi-execution',

            'service': 'ofa'

          },
          {

            'title': 'Analyse Salaire',

            'url': '/analyse-salaire',

            'service': 'ofa'

          },
          {

            'title': 'Suivi Analyse',

            'url': '/suivi-ofa',

            'service': 'ofa'

          },

          {

            'title': 'Mise en oeuvre',

            'url': '/mise-oeuvre',

            'service': 'ofa'

          },

          {

            'title': 'Synthèse globale',

            'url': '/synthese-gobale',

            'service': 'ofa'

          },

          {

            'title': 'Session d\'arbitrage',

            'url': '/session-arbitrage',

          },
          {

            'title': 'Ajustement Codir',

            'url': '/ajustement-codir',

          },

          {

            'title': 'Recap soldes',

            'url': '/recap-solde',

            'service': 'ofa'

          },
        ]
      },
      {
        'title': 'Reporting',
        'url': '',
        'service': 'ofa',
        'childrens': [
          {
            'title': 'Reporting OFA',
            'url': '/reporting-ofa',
          },
          {
            'title': 'Bilan OFA',
            'url': '/reporting/bilan-ofa',
            'service': 'ofa'
          }
        ]
      },

      {
        'title': 'Paramétrages',
        'url': '',
        'service': 'ofa',
        'childrens': [
          {

            'title': 'Soldes',

            'url': '/definition-solde',

            'service': 'ofa'

          },

          {

            'title': 'Seuils',

            'url': '/definition-seuils',

            'service': 'ofa'

          },
          {

            'title': 'Types de courrier',

            'url': '/type-courrier',

            'service': 'ofa'

          }
        ]
      },

    ]

  }

]

export const NAVIGATION_SUPER: any[] = [
  {
    title: 'Gestion des formations',
    url: '/gestion-reportings',
    icon: 'ft-archive ',
    childrens: [
      {
        'title': 'Catalogue formation',
        'url': '/catalogue-formation',
        'service': 'eia'
      },
      {
        'title': 'Formations',
        'url': '/formation-agent',
        'service': 'eia'
      },
      {
        'title': 'Historiques formations',
        'url': '/report-formation',
        'service': 'eia'
      }
    ]
  }
]

export const NAVIGATION_SUPER_ADMIN: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },
  {

    'heading': true,

    'title': 'OFA'

  },
  {

    'title': 'Ma structure OFA',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Organisation',

        'url': '/organisation-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Affectations OFA',

        'url': '/affectations-ofa',

        'service': 'ofa'

      }

    ]

  },

  {

    'title': 'MES OFA',

    'url': '/mes-ofa',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mes propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Mon arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Conseil de direction',

    'url': '/conseil-direction',

    'icon': 'ft-book-open',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Session d\'arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Campagne OFA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-ofa',

        'service': 'eia'

      },

      {

        'title': 'Suivi',

        'url': '/suivi-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Reporting',

        'url': '/reporting-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Structures',

        'url': '/structures',

        'service': 'ofa'

      },

      {

        'title': 'Agents',

        'url': '/agents-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Infos salaires',

        'url': '/infos-salaires',

        'service': 'ofa'

      },

      {

        'title': 'Historique OFA',

        'url': '/historique-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Historique hors OFA',

        'url': '/historique-hors-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Paramétrage des soldes',

        'url': '/definition-solde',

        'service': 'ofa'

      },

      {

        'title': 'Paramétrage des seuils',

        'url': '/definition-seuils',

        'service': 'ofa'

      },

      {

        'title': 'Gestion types de courrier',

        'url': '/type-courrier',

        'service': 'ofa'

      }

    ]

  },

  {

    'heading': true,

    'title': 'DATABOOK'

  },

  {

    'title': 'Moi',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mon DataBook',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques ofa',

        'url': '/mes-historiques-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques hors ofa',

        'url': '/mes-historiques-horsofa',

        'service': 'ofa'

      },
    ]

  },

  {

    'title': 'Mes collaborateurs',

    'url': '/mon-databook/collaborateurs',

    'service': 'ofa',
    'icon': 'ft-users'

  },

  {

    'title': 'Liste DataBook',

    'url': '/liste-databook',

    'icon': 'ft-book',

    'service': 'ofa'

  },

  {

    'heading': true,

    'title': 'Administration'

  },

  {

    'title': 'Paramètres',

    'url': '/settings',

    'icon': 'ft-settings',

    'service': '*',

    'childrens': [

      {

        'title': 'Administrateurs',

        'url': '/utilisateurs/creation'

      },

      {

        'title': 'Utilisateurs',

        'url': '/agents'

      },

      {

        'title': 'Profil',

        'url': '/utilisateurs/profil'

      },

      {

        'title': 'Log',

        'url': '/log'

      }

    ]

  }

]

export const NAVIGATION_SUPER_ADMIN_HIERARCHIE: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Ma structure OFA',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Organisation',

        'url': '/organisation-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Affectations OFA',

        'url': '/affectations-ofa',

        'service': 'ofa'

      }

    ]

  },

  {

    'title': 'MES OFA',

    'url': '/mes-ofa',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mes propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Mon arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Conseil de direction',

    'url': '/conseil-direction',

    'icon': 'ft-book-open',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Propositions',

        'url': '/propositions',

        'service': 'ofa'

      },

      {

        'title': 'Session d\'arbitrage',

        'url': '/session-arbitrage',

        'service': 'ofa'

      },

      {

        'title': 'Recap soldes',

        'url': '/recap-solde',

        'service': 'ofa'

      },

    ]

  },

  {

    'title': 'Campagne OFA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-ofa',

        'service': 'eia'

      },

      {

        'title': 'Suivi',

        'url': '/suivi-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Reporting',

        'url': '/reporting-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Structures',

        'url': '/structures',

        'service': 'ofa'

      },

      {

        'title': 'Agents',

        'url': '/agents-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Infos salaires',

        'url': '/infos-salaires',

        'service': 'ofa'

      },

      {

        'title': 'Historique OFA',

        'url': '/historique-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Historique hors OFA',

        'url': '/historique-hors-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Paramétrage des soldes',

        'url': '/definition-solde',

        'service': 'ofa'

      },

      {

        'title': 'Paramétrage des seuils',

        'url': '/definition-seuils',

        'service': 'ofa'

      },

      {

        'title': 'Gestion types de courrier',

        'url': '/type-courrier',

        'service': 'ofa'

      }

    ]

  },

  {

    'heading': true,

    'title': 'DATABOOK'

  },

  {

    'title': 'Moi',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Mon DataBook',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques ofa',

        'url': '/mes-historiques-ofa',

        'service': 'ofa'

      },

      {

        'title': 'Mes historiques hors ofa',

        'url': '/mes-historiques-horsofa',

        'service': 'ofa'

      },
    ]

  },

  {

    'title': 'Mes collaborateurs',

    'url': '/mon-databook/collaborateurs',

    'service': 'ofa',
    'icon': 'ft-users'

  },

  {

    'title': 'Liste DataBook',

    'url': '/liste-databook',

    'icon': 'ft-book',

    'service': 'ofa'

  },

  {

    'heading': true,

    'title': 'Administration'

  },

  {

    'title': 'Paramètres',

    'url': '/settings',

    'icon': 'ft-settings',

    'service': '*',

    'childrens': [

      {

        'title': 'Administrateurs',

        'url': '/utilisateurs/creation'

      },

      {

        'title': 'Utilisateurs',

        'url': '/agents'

      },

      {

        'title': 'Profil',

        'url': '/utilisateurs/profil'

      },

      {

        'title': 'Log',

        'url': '/log'

      }

    ]

  }

]

export const NAVIGATION_ADMIN: any[] = [
  {
    heading: true,
    title: 'Administration'
  },
  {
    title: 'Paramètres',
    url: '/settings',
    icon: 'ft-settings',
    childrens: [
      {
        title: 'Administrateurs',
        url: '/utilisateurs/creation'
      },
      {
        title: 'Utilisateurs',
        url: '/agents'
      },
      {
        title: 'Profil',
        url: '/utilisateurs/profil'
      }
    ]
  },
];
